import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-link-download-bgt',
    templateUrl: './link-download-bgt.component.html',
    styleUrls: ['./link-download-bgt.component.scss'],
    imports: [RouterLink]
})
export class LinkDownloadBgtComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
